var map = {
	"./ios-ivisita-login.avif": 1,
	"./ios-ivisita.avif": 3221,
	"./ios-ivisita.png": 7901,
	"./keyp.avif": 9149,
	"./keyp.png": 6691,
	"./mms.gif": 8912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5314;